/* eslint-disable import/prefer-default-export */
export const cardSettingsScreens = {
  VERIFY_PASSWORD: 'verify_password',
  SET_PIN: 'set_pin',
  REPORT_CARD_ISSUE: 'report_card_issue',
  CONFIRM_DETAILS: 'confirm_details',
  REPORT_CARD_CONFIRM: 'report_card_confirm',
  CONFIRM_REPLACEMENT_CARD_DETAILS: 'confirm_replacement_card_details',
  ORDER_REPLACEMENT_CARD: 'order_replacement_card',
  LAST_FIVE_TRANSACTIONS: 'last_five_transactions',
  EDIT_MAILING_ADDRESS: 'edit_mailing_address',
  CONFIRM_DELIVERY_TYPE: 'confirm_delivery_type',
  NOT_RECOGNIZED_TX: 'not_recognized_tx',
  CONFIRM_EXPEDITED_AMOUNT: 'confirm_expedited_amount',
  ERROR_TX: 'error_tx',
};
